import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { OidcCallbackPage } from '@/features/auth/oidc/oidc-callback-page'

const searchSchema = z.object({
  exchange: z.string().optional(),
  error: z.string().optional(),
})

export const Route = createFileRoute('/(auth)/sign-in/callback')({
  component: OidcCallbackPage,
  validateSearch: searchSchema,
})
